import { render, staticRenderFns } from "./closeWork.vue?vue&type=template&id=ce28afd4&"
import script from "./closeWork.vue?vue&type=script&lang=js&"
export * from "./closeWork.vue?vue&type=script&lang=js&"
import style0 from "./closeWork.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports